import React, { useRef, useState, useEffect, useCallback } from 'react';
import './index.css';
import { ReactComponent as SearchIcon } from 'common/icons/search.svg';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material';
import _ from 'lodash';

const InputWrapper = styled.div`
    display:flex;
    gap:14px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    width: 491px;
    padding: 7px 14px;
    align-items: center;
    cursor: text;
`;

const Input = styled.input`
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 100%;
    color: ${(props) => props.theme.colors.primaryTextColor};
    letter-spacing: 1px;
    &::placeholder {
        color: ${(props) => props.theme.colors.gray};
    }
`;

const SeachIconWrapper = styled.div<IconWrapperProps>`
    height: ${(props) => props.iconSize || 24}px;
    width: ${(props) => props.iconSize || 24}px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

type IconWrapperProps = {
  iconSize?: number;
};

type SearchInputProps = {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  style?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
  searchFunction?: (value: string) => void;
  iconSize?: number;
};

export default function SearchInput({ value, onChange = ()=>{}, placeholder, iconSize, className, wrapperStyle, style, searchFunction = ()=>{} }:SearchInputProps) {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const theme = useTheme();

  const handleHoverIn = () => {
    setIsFocused(true);
  };
  const handleHoverOut = () => {
    setIsFocused(false);
  };
  const handleWrapperClick = () => {
    inputRef.current?.focus();
    setIsFocused(true);
  };
  const handleInputFocus = () => {
    setIsFocused(true);
  };
  const handleInputBlur = () => {
    setIsFocused(false);
  };
  const debounceFn = useCallback(_.debounce((val) => searchFunction(val || ''), 300), []);
  // On enter press
  useEffect(() => {
    debounceFn(value);
  }, [value, debounceFn]);
  const handleSearchIconClick = () => {
    searchFunction(value || '');
  };

  return (
    <InputWrapper style={wrapperStyle} onClick={handleWrapperClick}>
        <SeachIconWrapper iconSize={iconSize} onClick={handleSearchIconClick} onMouseEnter={handleHoverIn} onMouseLeave={handleHoverOut}>
            <SearchIcon className='svg-black' style={{ transition: 'stroke .3s ease-in-out', stroke:isFocused ? theme.colors.primaryColor : theme.colors.black }}
                        height={iconSize || 24} width={iconSize || 24}/>
        </SeachIconWrapper>
        <Input value={value} className={className} style={style}
               onChange={(e)=>{onChange(e.target.value);}} onBlur={handleInputBlur}
               onFocus={handleInputFocus} ref={inputRef} placeholder={placeholder || 'Пошук...'}></Input>
    </InputWrapper>
  );
}